import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';

export const usePdfGeneration = () => {
  const generatePdf = async (element: HTMLElement | null) => {
    if (!element) return null;

    // Aumenta la scala per una migliore risoluzione dell'immagine
    const canvas = await html2canvas(element, { scale: 2 });
    const imgData = canvas.toDataURL('image/png');

    const pdf = new jsPDF('p', 'mm', 'a4');
    const pageW = pdf.internal.pageSize.getWidth();
    const pageH = pdf.internal.pageSize.getHeight();
    const margin = 5; // 10mm

    const pdfWidth = pageW - (margin * 2);
    const pdfHeight = pageH;

    const canvasWidth = canvas.width;
    const canvasHeight = canvas.height;

    // Adatta l'immagine alla larghezza utile del PDF
    const ratio = pdfWidth / canvasWidth;
    const imgHeight = canvasHeight * ratio;

    let heightLeft = imgHeight;
    let position = 0;

    // Aggiungi la prima pagina con i margini
    pdf.addImage(imgData, 'PNG', margin, position, pdfWidth, imgHeight);
    heightLeft -= pdfHeight;

    // Aggiungi le pagine successive se necessario
    while (heightLeft > 0) {
      position -= pdfHeight;
      pdf.addPage();
      pdf.addImage(imgData, 'PNG', margin, position, pdfWidth, imgHeight);
      heightLeft -= pdfHeight;
    }

    return pdf.output('blob');
  };

  return { generatePdf };
};
